import * as React from "react";
import { ClientWizardStateStore } from "src/stores/wizard/ClientWizardStateStore";
import { observer, inject } from "mobx-react";

interface WizardProps {
  wizardState?: ClientWizardStateStore;
  lobName: string;
}

// Component that extract the logic to determinate whether a form needs to be rendered base on the WizardState
export const Wizard: React.FunctionComponent<WizardProps> = inject("wizardState")(
  observer(({ wizardState, lobName, children }) => {
    if (!wizardState) {
      return null;
    }

    if (wizardState.activeLob !== lobName) {
      return null;
    } else {
      return <React.Fragment>{children}</React.Fragment>;
    }
  })
);
